import { render, staticRenderFns } from "./CheckoutPaymentFailure.vue?vue&type=template&id=2aa64c91&scoped=true"
import script from "./CheckoutPaymentFailure.vue?vue&type=script&lang=ts"
export * from "./CheckoutPaymentFailure.vue?vue&type=script&lang=ts"
import style0 from "./CheckoutPaymentFailure.vue?vue&type=style&index=0&id=2aa64c91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa64c91",
  null
  
)

export default component.exports